import angular from 'angular';
import filter from 'lodash/filter';
import find from 'lodash/find';
import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';
import take from 'lodash/take';
import includes from 'lodash/includes';

class CartBarsService {
    constructor(windowDimensionsService) {
        this.mullionSetups = [];
        this.windowDimensionsService = windowDimensionsService;
    }

    setMullionSetups(setups) {
        this.originalSetups = cloneDeep(setups);
        this.mullionSetups = this.filterMullionSetups(setups);
    }

    refreshDimensions() {
        this.mullionSetups = this.filterMullionSetups(cloneDeep(this.originalSetups));
    }

    filterMullionSetups(setups) {
        return filter(setups, (setup) => {
            if (setup && ['custom', 'simple'].indexOf(setup.type) === -1) {
                const currentSetup = this.filterIntSashes(setup);
                if (!currentSetup) {
                    return null;
                }
                const attributes = currentSetup.configuration.attributes;

                if (attributes.dividersHorizontal > 0 || attributes.dividersVertical > 0 ||
                    attributes.muntinsHorizontal > 0 || attributes.muntinsVertical > 0) {
                    currentSetup.display = `${currentSetup.name} ${currentSetup.size}`;
                    return currentSetup;
                }
            }
            return null;
        });
    }

    filterIntSashes(setup) {
        if (!setup.api_configuration) {
            return false;
        }
        const currentSetup = setup;
        const sash = find(setup.api_configuration.sashes, el =>
            el.type.type !== 'F');

        const newIntDividers = [];
        let dividers = 0;
        if (sash) {
            forEach(sash.intDividers, (el) => {
                if (el.direction === 'horizontal' && el.position < this.windowDimensionsService.height) {
                    const divider = find(newIntDividers, el1 =>
                        el1.position === el.position);
                    if (!divider) {
                        dividers++;
                    }
                    newIntDividers.push(el);
                }
            });

            forEach(setup.api_configuration.sashes, (el) => {
                const currentSash = el;
                currentSash.intDividers = cloneDeep(newIntDividers);
            });
            currentSetup.configuration.attributes.dividersHorizontal = dividers;
            return currentSetup;
        }
        dividers = 0;
        const sashesNumber = (setup.configuration.attributes.dividersHorizontal + 1) *
            (setup.configuration.attributes.dividersVertical + 1);
        const fixedDividers = [];
        const sashes = take(setup.api_configuration.sashes, sashesNumber).map(el => el.id);

        forEach(setup.api_configuration.dividers, (el) => {
            let isOk = el.direction === 'horizontal';
            if (isOk) {
                forEach(el.adjacentSashes.bottom, (el1) => {
                    if (!includes(sashes, el1)) {
                        isOk = false;
                    }
                });

                forEach(el.adjacentSashes.top, (el1) => {
                    if (!includes(sashes, el1)) {
                        isOk = false;
                    }
                });
            }
            if (isOk && el.position < this.windowDimensionsService.height) {
                const divider = find(fixedDividers, el1 =>
                    el1.position === el.position);
                if (!divider) {
                    dividers++;
                }
                fixedDividers.push(el);
            }
        });
        currentSetup.configuration.attributes.dividersHorizontal = dividers;
        const fixedSetup = {
            type: {
                type: 'SWF',
            },
            intSashes: take(setup.api_configuration.sashes, sashesNumber),
            intDividers: fixedDividers,
        };
        currentSetup.api_configuration.sashes.push(fixedSetup);

        return currentSetup;
    }

    getMullionsSetups() {
        return this.mullionSetups;
    }
}

CartBarsService.$inject = ['windowDimensionsService'];

export default angular.module('cartBarsService', [])
    .service('cartBarsService', CartBarsService)
    .name;